import { useRef, useState } from 'react'
import templateInvoiceApi from 'api/templateInvoiceApi'
import {
  setActivePanel,
  setActiveRegionBaseOnName,
  setSpecifiedDataField,
  setSpecifiedRegion,
} from 'features/TemplateInvoice/templateInvoiceSlice'
import ToastHelper from 'general/helpers/ToastHelper'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import DetailControl from './components/DetailControl'
import GeneralControl from './components/GeneralControl'
import LogoControl from './components/LogoControl'
import MainControl from './components/MainControl'
import SurroundBackgroundSelect from './components/SurroundBackgroundSelect'
import { setAppSpinning } from 'app/appSlice'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import { useAppSelector } from 'hooks/useRedux'
import { useFormik } from 'formik'
import { Tour } from 'antd'
import { getParam } from 'general/utils/Utils'

function RightControl(props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  let { templateInvoiceId } = useParams()
  const { className, style, prepareTemplateInvoiceParams, templateInvoice } =
    props
  const [isBusinessInvoice, setIsBusinessInvoice] = useState(false)

  const { company } = useAppSelector((state) => state.system)

  const { activePanel, activeRegion, configDynamicFieldPanel } = useSelector(
    (state) => state.templateInvoice,
  )
  const { templateInvoiceForm } = useSelector(
    (state) => state.templateInvoice.instance,
  )
  const type = getParam('type')
  const [openTour, setOpenTour] = useState(false)
  const [current, setCurrent] = useState(0)
  const [showModalConfirmBack, setShowModalConfirmBack] = useState(false)
  const [showModalConfirmSave, setShowModalConfirmSave] = useState(false)

  useEffect(() => {
    if (activePanel !== 'detail_ctrl') {
      dispatch(setActiveRegionBaseOnName(null))
    }
  }, [activePanel])

  useEffect(() => {
    if (templateInvoiceForm !== undefined) {
      dispatch(
        setSpecifiedDataField({
          regionName: 'invoiceInfo',
          dataFieldName: 'invoiceCode',
          propertyData: { show: !!templateInvoiceForm },
        }),
      )
    }
  }, [templateInvoiceForm])

  const createTemplateInvoiceHandler = async () => {
    let params = await prepareTemplateInvoiceParams()
    if (isBusinessInvoice) {
      let useBusinessBranch = isBusinessInvoice
      let businessBranchName = formik.values.businessBranchName
      let businessBranchCode = formik.values.businessBranchCode
      let businessBranchAddress = formik.values.businessBranchAddress
      if (
        !businessBranchName ||
        !businessBranchCode ||
        !businessBranchAddress
      ) {
        ToastHelper.showError(
          'Thông tin địa điểm kinh doanh không thể để trống!',
        )
        return
      }
      params.useBusinessBranch = useBusinessBranch
      params.businessBranchName = businessBranchName
      params.businessBranchCode = businessBranchCode
      params.businessBranchAddress = businessBranchAddress
    } else {
      params.useBusinessBranch = isBusinessInvoice
      params.businessBranchName = null
      params.businessBranchCode = null
      params.businessBranchAddress = null
    }
    dispatch(setAppSpinning(true))
    var res
    try {
      res = await templateInvoiceApi.createTemplate(params)
    } catch (e) {
      console.log(e)
    } finally {
      dispatch(setAppSpinning(false))
    }

    if (res?.template) {
      ToastHelper.showSuccess('Tạo mẫu hóa đơn thành công!')
      navigate('/hoa-don-dau-ra/mau-hoa-don')
    }
  }

  const formik = useFormik({
    initialValues: {
      businessBranchCode: company?.businessBranchCode ?? null,
      businessBranchName: company?.businessBranchName ?? null,
      businessBranchAddress: company?.businessBranchAddress ?? null,
    },
    onSubmit: async (values) => {},
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
  })

  const updateTemplateInvoiceHandler = async () => {
    let params = await prepareTemplateInvoiceParams()
    if (isBusinessInvoice) {
      let useBusinessBranch = isBusinessInvoice
      let businessBranchName = formik.values.businessBranchName
      let businessBranchCode = formik.values.businessBranchCode
      let businessBranchAddress = formik.values.businessBranchAddress
      if (
        !businessBranchName ||
        !businessBranchCode ||
        !businessBranchAddress
      ) {
        ToastHelper.showError(
          'Thông tin địa điểm kinh doanh không thể để trống!',
        )
        return
      }
      params.useBusinessBranch = useBusinessBranch
      params.businessBranchName = businessBranchName
      params.businessBranchCode = businessBranchCode
      params.businessBranchAddress = businessBranchAddress
    } else {
      params.useBusinessBranch = isBusinessInvoice
      params.businessBranchName = null
      params.businessBranchCode = null
      params.businessBranchAddress = null
    }
    dispatch(setAppSpinning(true))
    var res
    try {
      res = await templateInvoiceApi.updateTemplate(templateInvoiceId, params)
    } catch (e) {
      console.log(e)
    } finally {
      dispatch(setAppSpinning(false))
    }
    if (res) {
      ToastHelper.showSuccess('Sửa mẫu hóa đơn thành công!')
      navigate('/hoa-don-dau-ra/mau-hoa-don')
    }
  }

  const handleConfirmBack = () => {
    history.back()
  }

  const handleConfirmSave = () => {
    updateTemplateInvoiceHandler()
  }

  console.log('templateInvoice', templateInvoice)

  const refGeneralSetting = useRef(null)
  const steps = [
    {
      title: 'Thiết lập chung',
      description:
        'Nhấn vào đây để cấu hình tên mẫu, ký hiệu, font chữ, cỡ chữ, QR Code, song ngữ và các tùy chọn hiển thị hóa đơn, thiết lập thông tin địa điểm kinh doanh',
      target: () => refGeneralSetting.current,
      placement: 'right', // hoặc 'left', 'bottom', 'top'
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'Thiết lập thông tin địa điểm kinh doanh',
      description: 'Nhấn vào đây để cấu hình thông tin địa điểm kinh doanh',
      target: () => refGeneralSetting.current,
      placement: 'right', // hoặc 'left', 'bottom', 'top'
      prevButtonProps: {
        children: 'Quay lại',
      },
      nextButtonProps: {
        children: 'Hoàn thành',
      },
    },
  ]

  useEffect(() => {
    if (type === 'businessBranchCode' && !openTour) {
      setOpenTour(true)
    }
  }, [type])

  return (
    <div className={`${className} RightControl`} style={style}>
      <div className="d-flex flex-column justify-content-between h-100">
        <Tour
          open={openTour}
          current={current}
          steps={steps}
          onClose={() => {
            setOpenTour(false)
            const url = new URL(window.location.href)
            url.searchParams.delete('type')
            window.history.replaceState({}, '', url)
          }}
          onChange={(current) => {
            console.log('Đang ở step:', current)
            if (current == 1) {
              dispatch(setActivePanel('gen_ctrl'))
            }
            setCurrent(current)
          }}
        />
        {(function () {
          switch (activePanel) {
            case 'main_ctrl':
              return (
                <MainControl
                  steps={steps}
                  openTour={openTour}
                  type={type}
                  refGeneralSetting={refGeneralSetting}
                  setCurrent={setCurrent}
                />
              )
            case 'gen_ctrl':
              return (
                <GeneralControl
                  style={{ flex: '1 1 auto' }}
                  isBusinessInvoice={isBusinessInvoice}
                  setIsBusinessInvoice={setIsBusinessInvoice}
                  formik={formik}
                  templateInvoice={templateInvoice}
                  refGeneralSetting={refGeneralSetting}
                />
              )
            case 'logo_ctrl':
              return <LogoControl style={{ flex: '1 1 auto' }} />
            case 'detail_ctrl':
              return <DetailControl style={{ flex: '1 1 auto' }} />

            case 'surround_sel':
            case 'background_sel':
            case 'background_surround_sel':
              return <SurroundBackgroundSelect style={{ flex: '1 1 auto' }} />
            default:
              return <MainControl />
          }
        })()}

        <div className="" style={{ flex: '0 1 auto' }}>
          {['tableDetail', 'tableDetail1'].includes(activeRegion?.regionName) &&
            !configDynamicFieldPanel && (
              <div className="d-flex flex-row justify-content-between align-items-center bg-secondary p-2 mb-2">
                <input
                  className="cursor-pointer"
                  type="checkbox"
                  defaultChecked
                  style={{ width: '1.5rem', height: '1.5rem' }}
                />
                <p className="mb-0">
                  Số dòng hàng hóa dịch vụ hiển thị tối thiểu
                </p>
                <input
                  type="number"
                  className="form-control number-input"
                  value={activeRegion?.minItemRows}
                  min={1}
                  max={20}
                  onChange={(e) => {
                    if (
                      e.target.value < 1 ||
                      e.target.value > 20 ||
                      !e.target.value
                    )
                      return
                    dispatch(
                      setSpecifiedRegion({
                        regionName: activeRegion?.regionName,
                        propertyData: { minItemRows: parseInt(e.target.value) },
                      }),
                    )
                  }}
                />
              </div>
            )}

          {!configDynamicFieldPanel && (
            <div className="d-flex flex-row justify-content-between">
              {[
                'surround_sel',
                'background_sel',
                'background_surround_sel',
              ].includes(activePanel) ? (
                <>
                  <button
                    type="button"
                    className="px-10 py-2 btn btn-outline-secondary"
                    onClick={() => dispatch(setActivePanel('logo_ctrl'))}
                  >
                    Hủy
                  </button>

                  <button
                    type="button"
                    className="px-10 py-2 btn btn-primary"
                    onClick={() => dispatch(setActivePanel('logo_ctrl'))}
                  >
                    Chọn
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="px-10 py-2 btn btn-outline-secondary"
                    onClick={() => setShowModalConfirmBack(true)}
                  >
                    Hủy bỏ
                  </button>

                  <button
                    type="button"
                    className="px-10 py-2 btn btn-primary"
                    onClick={
                      pathname.includes('/tao/')
                        ? createTemplateInvoiceHandler
                        : pathname.includes('/sua/')
                          ? () => setShowModalConfirmSave(true)
                          : null
                    }
                  >
                    Lưu
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      <ModalConfirm
        show={showModalConfirmBack}
        setShow={setShowModalConfirmBack}
        header="Dữ liệu đã thay đổi"
        content="Dữ liệu đã bị thay đổi. Bạn chắc chắn vẫn muốn thoát?"
        handleConfirm={handleConfirmBack}
      />

      <ModalConfirm
        show={showModalConfirmSave}
        setShow={setShowModalConfirmSave}
        header="Xác nhận"
        content="Khi sửa mẫu hóa đơn, những nội dung thay đổi trên mẫu sẽ được cập nhật trên tất cả các hóa đơn đã phát hành thuộc mẫu hóa đơn này. Bạn có muốn tiếp tục sửa không?"
        handleConfirm={handleConfirmSave}
      />
    </div>
  )
}

export default RightControl
